(() => {
  for (const link of document.querySelectorAll('[data-preserve-query]')) {
    const next = new URL(link.href, location.href);
    for (const [key, value] of new URLSearchParams(location.search)) {
      if (key !== 'variant' && key !== 'view' && !next.searchParams.has(key)) next.searchParams.append(key, value);
    }
    link.href = next.href;
  }
  const dialog = document.querySelector('.studio-zoom');
  let opener;
  if (!dialog || typeof dialog.showModal !== 'function') return;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-zoom]');
    if (link) {
      event.preventDefault(); opener = link;
      const image = dialog.querySelector('img'); image.src = link.href;
      image.alt = link.querySelector('img')?.alt || '';
      const caption = dialog.querySelector('[data-zoom-caption]');
      if (caption) { caption.textContent = link.dataset.caption || ''; caption.hidden = !caption.textContent; }
      dialog.showModal();
    }
    if (event.target.closest('[data-close-zoom]') || event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => opener?.focus());
})();
